<template>
  <TemplateCreateNormal
    :boardTitle="boardTitle"
    :fileUpLoadAction="fileUpLoad.action"
    :fileUpLoadHeaders="fileUpLoad.headers"

    @handleClickRegister="handleClickRegister"
    @handleClickCancel="handleClickCancel"
    @handleChangeFile="handleChangeFile"
    @handleSuccessFileUpload="handleSuccessFileUpload"
    @handleDeleteFile="handleDeleteFile"
  ></TemplateCreateNormal>
</template>

<script>
import config from '/public/config'
import TemplateCreateNormal from '@/views/board/template/create/TemplateCreateNormal'

import VueCookie from 'vue-cookie'
export default {
  name: 'BoardCreate',
  components: {
    TemplateCreateNormal
  },
  data () {
    return {
      boardId: '',
      boardSlug: '',
      boardTitle: '',

      form: {
        title:''
      },

      // 파일 업로드 서버 정보
      fileUpLoad:{
        headers: '',
        action:`${config.BASE_API_URL}/api/v1/file`,
        files: [] // 등록하고자 하는 파일 목록
      }
    }
  },
  created () {
    this.boardSlug = this.$route.params.boardslug

    if (this.boardSlug === 'notice') {
      this.boardTitle = '공지사항'
      this.boardId = 1
    } else if (this.boardSlug === 'notice2') {
      this.boardTitle = '공지사항'
      this.boardId = 1
    } else if (this.boardSlug === 'faq') {
      this.boardTitle = 'FAQ'
      this.boardId = 1
    } else if (this.boardSlug === 'service') {
      this.boardTitle = '고객센터'
      this.boardId = 1
    }

    // file upload 시 사용되는 xmlrequest header
    this.fileUpLoad.headers = {
      Authorization: `Bearer ${VueCookie.get('token')}`
    }
  },
  methods: {
    async registerPost (_title, _content) {

      const boardId = this.boardId
      const title = _title
      const content = _content
      let uploads = ''
      if (this.fileUpLoad.files.length > 0) {
        const upload = []
        for (const temp of this.fileUpLoad.files) {
          upload.push(temp.uploadedFileId)
        }
        uploads = JSON.stringify(upload)
      }

      await this.$store.dispatch('board/CREATE_POST', {boardId, title, content, uploads})

      this.$router.back()
    },

    handleClickRegister (_title, _content) {
      this.registerPost(_title, _content)
    },
    handleClickCancel () {
      this.$router.back()
    },
    handleChangeFile (path, files) {
      this.fileUpLoad.files = files
    },
    handleSuccessFileUpload (uploadedFileID) {
      const file = this.fileUpLoad.files[this.fileUpLoad.files.length - 1]
      file.uploadedFileId = uploadedFileID
    },
    handleDeleteFile (file) {
      this.fileUpLoad.files.remove(file)
    }
  }
}
</script>

<style scoped>

</style>
